import { RawDataSourceChart } from "components/RawDataSourceChart";
import { useGetData } from "hooks/useGetData";
import {
  BaseSeries,
  ChartData,
  DataSource,
  NonRawDatasource
} from "interfaces/chart";
import React from "react";

export interface ChartProps {
  chartData: ChartData;
}

const hasNonRawDataSource = (
  series: BaseSeries<DataSource>
): series is BaseSeries<NonRawDatasource> => {
  return series.dataSource.type !== "raw";
};

export const Chart = React.memo(function Chart({
  chartData
}: ChartProps): JSX.Element {
  // Translate the series by replacing the 'series' which tell us how to
  // get data with the actual data ready for plotting.

  let newChartData = JSON.parse(JSON.stringify(chartData));

  const nonRawSeriesWithIndex: {
    index: number;
    series: BaseSeries<NonRawDatasource>;
  }[] = [];

  chartData.series.forEach((series, index) => {
    if (hasNonRawDataSource(series)) {
      nonRawSeriesWithIndex.push({ index, series });
    }
  });
  const queryResults = useGetData(nonRawSeriesWithIndex.map(x => x.series));

  const newSeries = JSON.parse(JSON.stringify(newChartData.series));
  queryResults.forEach((queryResult, index) => {
    const originalIndex = nonRawSeriesWithIndex[index].index;
    const { isLoading, isError, data } = queryResult;
    if (isLoading || isError) {
      newSeries[originalIndex].dataSource = { type: "raw", args: { data: [] } };
    } else {
      newSeries[originalIndex].dataSource = { type: "raw", args: { data } };
    }
  });

  newChartData.series = newSeries;

  return (
    <RawDataSourceChart
      chart={newChartData}
      loading={queryResults.some(x => x.isLoading)}
    />
  );
});
